import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=d6580ac6&scoped=true&"
import script from "./GridView.vue?vue&type=script&lang=js&"
export * from "./GridView.vue?vue&type=script&lang=js&"
import style0 from "./GridView.vue?vue&type=style&index=0&id=d6580ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6580ac6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
